import colors from "../../../../styles/colors/colors";

export const TextArea = () => ({
  "& .MuiFormHelperText-root": {
    marginRight: 0,
    marginLeft: 0,
  },
  "& .css-w1u3ce>span": {
    padding: 0,
  },
});

export const DescriptionStyle = () => ({
  margin: "0.7rem",
  minWidth: "100%",
  marginLeft: "-0.1rem",
  background: colors.white[1],
});

export const PaddingTopBtm1rem = () => ({
  padding: "1rem 0",
});

export const OptionsContainer = () => ({
  padding: "1rem 0",
  paddingLeft: "0.7rem",
});

export const CareTypeStyle = () => ({
  display: "flex",
  flexDirection: "row",
  "& .MuiSwitch-root": { marginRight: "1rem" },
});

export const DisciplineStyle = () => ({
  display: "flex",
  flexDirection: "column",
  "& .MuiSwitch-root": { marginRight: "1rem" },
  maxHeight: "7rem",
});

export const DisplayBlock = () => ({
  display: "block",
});

export const RequiredSymbol = () => ({
  display: "flex",
});
